<template>
    <div class="block" v-if="visible">
        <div class="item">热烈祝贺 {{model.name}} 加入了联真签约维修服务网点</div>
    </div>
</template>

<script>
  export default {
    data(){
      return {
        visible:false,
        model:{
          name:"山西网点",
          time:"3wrewqrw"
        }
      }
    },
    methods:{
      show(model){
        this.model = model
        this.visible=true
        setTimeout(()=>{
          this.visible=false
        },8000)
      }
    }
  }
</script>

<style scoped>
.block{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100;
}

  .item{
    margin-top:400px;
    margin-right: 300px;
    background: rgba(21,146,230,0.2);
    font-size: 30px;
    color: #FFF;
    padding: 30px 60px;
    border: 0.5px solid #00F6FF;
    box-shadow: 0 0 100px rgba(10, 76, 139, 1);
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/views/home/board/RepairPointShow.vue